// Reusable avatar with photo fallback to initials gradient
export default function Avatar({ user, size = 40, className = "" }) {
  const s = { width: size, height: size };
  const initials = (user?.name || user?.user_name || "?").split(" ").map(x => x[0]).join("").slice(0, 2).toUpperCase();
  const src = user?.avatar_url;
  if (src) {
    return <img src={src} alt={user?.name || "avatar"} style={s}
                className={`rounded-full object-cover shrink-0 border border-slate-200 ${className}`}/>;
  }
  return (
    <div className={`rounded-full bg-gradient-to-br from-indigo-500 to-teal-500 grid place-items-center text-white font-semibold shrink-0 ${className}`}
         style={{ ...s, fontSize: Math.max(10, size * 0.35) }}>
      {initials}
    </div>
  );
}
